export default __webpack_public_path__ + "static/media/icon-status-cancel.ac7ff7ad.svg";